import {
  apiContainer,
  queryBuilder,
  massageSingleRecordBeforeUpsert
} from './apiContainer'

import { ArtificialDetailPropertyNames } from '../../common/globalNotary'

const SLICE_API_ROOT = '/datazones'

const datazonesApi = apiContainer.injectEndpoints({
  endpoints: build => ({
    listDataZones: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args)
    }),
    getOneDataZone: build.query({
      query: args => queryBuilder(SLICE_API_ROOT, args)
    }),

    getOneFatDataZone: build.query({
      async queryFn (_arg, _queryApi, _extraOptions, fetchWithBQ) {
        // get a random user
        const primaryCall = fetchWithBQ(`${SLICE_API_ROOT}/${_arg.id}`)
        const groupCall = fetchWithBQ(`/groups?datazone_id=${_arg.id}`)
        const geoShapeCall = fetchWithBQ(
          `${SLICE_API_ROOT}/${_arg.id}/geozones`
        )

        const res = await Promise.all([primaryCall, groupCall, geoShapeCall])
        const primaryData = res[0].data.data

        const groups = res[1].data.data
        const geoShapes = res[2].data.data

        primaryData[ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1] = groups
        primaryData[
          ArtificialDetailPropertyNames.DETACHED_DEPENDENCY1_INITIAL_VALUES
        ] = groups

        primaryData[ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2] =
          geoShapes
        primaryData[
          ArtificialDetailPropertyNames.DETACHED_DEPENDENCY2_INITIAL_VALUES
        ] = geoShapes

        return { data: { data: primaryData } }
      }
    }),

    bulkUpdateDatazones: build.mutation({
      query: args => {
        return {
          url: SLICE_API_ROOT,
          method: 'PATCH',
          body: { data: args }
        }
      }
    }),
    updateListOfGeometryShapesForGeozoneId: build.mutation({
      query: args => {
        return {
          url: SLICE_API_ROOT + `/${args.id}/geozones`,
          method: 'PUT',
          body: { data: args.data }
        }
      }
    }),
    upsertDataZone: build.mutation({
      query: args => {
        const { id } = args
        const actualArgs = massageSingleRecordBeforeUpsert(args)

        delete actualArgs.meta
        delete actualArgs.items

        if (actualArgs.hasOwnProperty('addresses')) {
          const newAddresses = []
          actualArgs.addresses.forEach(a => {
            delete a.created_at
            newAddresses.push(a)
          })

          actualArgs.addresses = newAddresses
        } else {
          actualArgs.addresses = [] // api wants addresses regardless - even if it is not required, even if it was never returned from the fetch call for commercial zones
        }

        if (id) {
          // update
          return {
            url: `${SLICE_API_ROOT}/${id}`,
            method: 'PUT',
            body: actualArgs
          }
        } //insert
        else {
          return {
            url: SLICE_API_ROOT,
            method: 'POST',
            body: actualArgs
          }
        }
      }
    }),
    deleteDataZone: build.mutation({
      query: args => {
        return {
          url: `${SLICE_API_ROOT}/${args.id}`,
          method: 'DELETE'
        }
      }
    })
  }),
  overrideExisting: true
})

export const {
  useUpdateListOfGeometryShapesForGeozoneIdMutation,
  useLazyListDataZonesQuery,
  useGetOneFatDataZoneQuery,
  useLazyGetOneFatDataZoneQuery,
  useUpsertDataZoneMutation,
  useDeleteDataZoneMutation,
  useBulkUpdateDatazonesMutation
} = datazonesApi
